<template>
  <div class="column_center_around login_card">
    <p class="card_title">免費登入</p>

    <button @click="login" class="mt-4 mb-5">使用LINE登入</button>
    <div class="row_center_center" style="font-size: 14px">
      <p style="color: #666666">若您選擇繼續，即表示您同意</p>
      <a href="https://www.okshop.tw/privacy/" target="_blank" style="color: #fd5001">條款與條件</a>
    </div>
  </div>
</template>
<script>
export default {
  props: {},
  methods: {
    login() {
      this.$emit("login");
    },
  },
};
</script>
<style lang="scss" scoped>
.login_card {
  border-radius: 6px;
  background-color: #fff;
  width: 90vw;
  height: 200px;
  padding: 30px 30px 20px 30px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
}

.card_title {
  color: #000;
  font-weight: 700;
  font-size: 24px;
  font-family: PingFang SC;
}

button {
  background-color: #06c755;
  border: none;
  width: 100%;
  height: 50px;
  border-radius: 6px;
  color: #fff;
  font-weight: 500;
  font-size: 20px;
  box-shadow: 0px 3px 6px #00000029;
}
</style>
